import { AxiosResponse } from 'axios'

import { apisiseci } from './api'

export const allCategory = (page: number): Promise<AxiosResponse> =>
  apisiseci.get(`cms/temas/?page=${page}`)

export const getCategory = (slug: string): Promise<AxiosResponse> =>
  apisiseci.get(`cms/temas/?slug=${slug}`)

export const filterCategory = (params: {
  search?: string
  page?: number
  slug?: string
}): Promise<AxiosResponse> =>
  apisiseci.get('cms/temas/', {
    params,
  })

export const listAllCategory = (): Promise<AxiosResponse> =>
  apisiseci.get('cms/temas/')

export const listAllCategoryEmphasis = (): Promise<AxiosResponse> =>
  apisiseci.get('/cms/servicos_destaque_portal')

export const getSubCategory = (slug_category: string): Promise<AxiosResponse> =>
  apisiseci.get(`/cms/subcategorias/?categoria=${slug_category}`)

export const getSubCategoryById = (id: string): Promise<AxiosResponse> =>
  apisiseci.get(`/cms/subcategorias/${id}`)
